import React, { useCallback, useRef, createContext } from 'react';
import classNames from 'classnames';
import { Transition, TransitionGroup } from 'react-transition-group';
import { ReactComponent as CiSvg } from '../components/icon/ci.svg';

import { useWindowWidth } from '../util';
import Header from '../components/Header';
import * as styles from './Layout.module.scss';

interface Props {
  children?: React.ReactNode;
}

export type MediaType = 'pc' | 'mobile';
export const MediaContext = createContext<MediaType>('mobile');

const Layout: React.FC<Props> = ({ children }) => {
  const location = typeof window !== 'undefined' ? window.location : '';
  const backToTop = useCallback((e: React.MouseEvent) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    e.preventDefault();
  }, []);
  const windowWidth = useWindowWidth();
  const mediaType = windowWidth >= 1000 ? 'pc' : 'mobile';
  const layoutDiv = useRef<HTMLDivElement>(null);
  return (
    <MediaContext.Provider value={mediaType}>
      <div ref={layoutDiv} className={classNames(styles.layout, styles[mediaType])}>
        <Header location={location} />
        <TransitionGroup component={null}>
          <Transition key={location.pathname} timeout={300}>
            {(state) => (
              <div id="top" className={classNames(styles.page, styles[state])}>
                <main>{children}</main>
                <Footer mediaType={mediaType} />
                <a href="#top" className={styles.backToTop} onClick={backToTop}>
                  <BackToTopIcon />
                </a>
              </div>
            )}
          </Transition>
        </TransitionGroup>
      </div>
    </MediaContext.Provider>
  );
};

export default Layout;

const BackToTopIcon = () => (
  <svg className={styles.backToTopIcon}>
    <g>
      <polyline points="40.72,24.44 28.5,12.22 16.28,24.44" />
      <line x1="28.5" y1="12.22" x2="28.5" y2="44.78" />
      <circle cx="28.5" cy="28.5" r="28" />
    </g>
  </svg>
);

interface FooterProps {
  mediaType: MediaType;
}
const Footer: React.FC<FooterProps> = ({ mediaType }) => {
  return (
    <footer className={classNames(styles.footer, styles[mediaType])}>
      <div className={styles.wrap}>
        <CiSvg />
        <p>© {new Date().getFullYear()} Devsisters Corp. All Rights Reserved.</p>
      </div>
    </footer>
  );
};
